<ui-select-top-control
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [nzId]="nzId"
  [open]="nzOpen"
  [disabled]="nzDisabled"
  [mode]="nzMode"
  [maxTagPlaceholder]="nzMaxTagPlaceholder"
  [removeIcon]="nzRemoveIcon"
  [placeHolder]="nzPlaceHolder"
  [maxTagCount]="nzMaxTagCount"
  [customTemplate]="nzCustomTemplate"
  [tokenSeparators]="nzTokenSeparators"
  [showSearch]="nzShowSearch"
  [autofocus]="nzAutoFocus"
  [listOfTopItem]="listOfTopItem"
  (inputValueChange)="onInputValueChange($event)"
  (tokenize)="onTokenSeparate($event)"
  (deleteItem)="onItemDelete($event)"
  (keydown)="onKeyDown($event)"></ui-select-top-control>
<ui-select-arrow *ngIf="nzShowArrow" [loading]="nzLoading" [search]="nzOpen && nzShowSearch" [suffixIcon]="nzSuffixIcon"></ui-select-arrow>
<ui-select-clear *ngIf="nzAllowClear && !nzDisabled && listOfValue.length" [clearIcon]="nzClearIcon" (clear)="onClearSelection()"></ui-select-clear>
<ng-template
  cdkConnectedOverlay
  nzConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="nzBackdrop"
  [cdkConnectedOverlayMinWidth]="$any(nzDropdownMatchSelectWidth ? null : triggerWidth)"
  [cdkConnectedOverlayWidth]="$any(nzDropdownMatchSelectWidth ? triggerWidth : null)"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayTransformOriginOn]="'.ant-select-dropdown'"
  [cdkConnectedOverlayPanelClass]="nzDropdownClassName!"
  [cdkConnectedOverlayOpen]="nzOpen"
  (overlayKeydown)="onOverlayKeyDown($event)"
  (overlayOutsideClick)="onClickOutside($event)"
  (detach)="setOpenState(false)"
  (positionChange)="onPositionChange($event)">
  <ui-option-container
    [ngStyle]="nzDropdownStyle"
    [itemSize]="nzOptionHeightPx"
    [maxItemLength]="nzOptionOverflowSize"
    [matchWidth]="nzDropdownMatchSelectWidth"
    [class.ant-select-dropdown-placement-bottomLeft]="dropDownPosition === 'bottom'"
    [class.ant-select-dropdown-placement-topLeft]="dropDownPosition === 'top'"
    [listOfContainerItem]="listOfContainerItem"
    [menuItemSelectedIcon]="nzMenuItemSelectedIcon"
    [notFoundContent]="nzNotFoundContent"
    [activatedValue]="activatedValue"
    [listOfSelectedValue]="listOfValue"
    [dropdownRender]="nzDropdownRender"
    [compareWith]="compareWith"
    [mode]="nzMode"
    (keydown)="onKeyDown($event)"
    (itemClick)="onItemClick($event)"
    (scrollToBottom)="nzScrollToBottom.emit()"></ui-option-container>
</ng-template>
